import { isLocal, isProduction } from '@/config/env';

export const getCookie = (name: string) => {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')[1];
};

export const setCookie = (
  name: string,
  value: string,
  options?: {
    domain?: string;
    path?: string;
    expires?: Date;
    secure?: boolean;
    sameSite?: 'Strict' | 'Lax' | 'None';
  },
) => {
  const {
    domain = isLocal() ? '' : `.${location.host}`, // 默认设置为顶级域名，允许所有子域名访问
    path = '/',
    expires = new Date(Date.now() + 1 * 365 * 24 * 60 * 60 * 1000), // 默认1年后过期，实现永不过期效果
    secure = isProduction(),
    sameSite = 'Lax',
  } = options || {};

  let cookieString = `${name}=${value}`;

  if (domain) cookieString += `; domain=${domain}`;
  if (path) cookieString += `; path=${path}`;
  if (expires) cookieString += `; expires=${expires.toUTCString()}`;
  if (secure) cookieString += '; secure';
  if (sameSite) cookieString += `; samesite=${sameSite}`;

  document.cookie = cookieString;
};

export const removeCookie = (name: string) => {
  // 提取顶级域名（如从 subdomain.xxxx.com 提取出 xxxx.com）
  const getTopLevelDomain = () => {
    if (isLocal()) return '';
    const hostParts = location.host.split('.');
    // 如果 host 包含至少两个部分（如 subdomain.xxxx.com），提取最后两个部分
    if (hostParts.length >= 2) {
      return `.${hostParts.slice(-2).join('.')}`;
    }
    return `.${location.host}`;
  };

  const topLevelDomain = getTopLevelDomain();

  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  if (topLevelDomain) {
    document.cookie = `${name}=; path=/; domain=${topLevelDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }
  // 也尝试删除当前 host 的 cookie（兼容性处理）
  document.cookie = `${name}=; path=/; domain=${location.host}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  document.cookie = `${name}=; path=/; domain=.${location.host}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
